import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GridService } from 'app/Shared/Services/grid.service';

import {default as RouteGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Routes-Columns.json';
import {default as TradeGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Trades-Columns.json';
import {default as OrderGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Orders-Columns.json';
import {default as ExceptionColumnsJSON} from '../common-grid/column-grid-json/exception-list-columns.json';
import {default as ExceptionColumnsForMarketAbuseJSON} from '../common-grid/column-grid-json/exception-list-columns-market-Abuse.json';
import { ExceptionDetailsService } from './exception-details.service';
import { updateStatus, Loading } from './exception-details.model';
import { MessageService } from 'primeng/api';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Exceptions } from '../common-grid/common-grid.model';
import { CommonGridService } from '../common-grid/common-grid.service';
import { DataService } from 'app/Shared/Services/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { FormsModule, NgModel } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TurboTableComponent } from 'app/Shared/Component/turbo-table/turbo-table.component';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MatInputModule } from '@angular/material/input';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { AccordionModule } from 'primeng/accordion';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-exception-details',
    imports: [CommonModule,MatAccordion, MatExpansionModule, DialogModule, FormsModule, Select,
        MatFormFieldModule, MatCheckboxModule, TurboTableComponent,
        MatProgressSpinner, TableModule, ToastModule, MatInputModule, MatIconModule, AccordionModule,],
    providers: [CommonGridService, ExceptionDetailsService],
    templateUrl: './exception-details.component.html',
    styleUrls: ['./exception-details.component.scss']
})
export class ExceptionDetailsComponent implements OnInit {
  isShowDialog: boolean = true;
  panelOpenState: boolean = true;
  exceptionPanelOpenState: boolean = false;
  orderDataPanelOpenState: boolean = false;
  activityDetails: Array<any>= [];
  @Input() selectedRow!: Exceptions;
  @Input() pageName!: string;
  @Input() defaultFilterArray: any;
  OrderGridCols: any = [];
  orderData: any = [];
  tradeData: any = [];
  routeData: any = [];
  exceptionList: any = [];
  ExceptionGridCols: any = [];
  TradeGridCols: any = [];
  RouteGridCols: any = [];
  tbldatamsg = "L o a d i n g . . . . .";
  loading:Loading =new Loading();
  status = [
    { label: 'Select Status', value: null },
    { label: 'Open', value: 'Open' },
    { label: 'Reopen', value: 'Reopen' },
    { label: 'Close', value:  'Close' },
  ];
  userList: any = [];
  selectedUser: any;
  cols = [
    { field: 'status', header: 'Status' },
    { field: 'createDateTime', header: 'DateTime' },
    { field: 'owner', header: 'Owner' },
    { field: 'comments', header: 'Comments' },
    { field: 'orderExcepCommentID', header: 'Attachment' }
  ];

  updateStatus :  updateStatus = new updateStatus();
  limit: any = { 'Start': '0', 'End': '15' };
  isOrder:boolean =true;
  isTrade: boolean = true;
  isRoute: boolean = true;
  showAccordian:boolean[]=[true];
  totalRecords: number = 0;

  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public frontRunningService: CommonGridService,
    public gridService: GridService,
    public exceptionDetailsService: ExceptionDetailsService,
    private messageService:MessageService,
    public constantService:ConstantService,
    public dataService: DataService
  ) {
    this.OrderGridCols = this.gridService.getGridColumns(OrderGridColumnsJSON["Orders-Grid-Columns"]);
    this.TradeGridCols = this.gridService.getGridColumns(TradeGridColumnsJSON["Trades-Grid-Columns"]);
    this.RouteGridCols = this.gridService.getGridColumns(RouteGridColumnsJSON["Routes-Grid-Columns"]);
    
  }

  ngOnInit() {
    this.ExceptionGridCols = this.pageName === 'Front Running' || this.pageName === 'Reg Sho'
    ? this.gridService.getGridColumns(ExceptionColumnsJSON)
    :this.gridService.getGridColumns(ExceptionColumnsForMarketAbuseJSON);
    this.exceptionDetailsService.getUserList()
    .subscribe((data) => {
      this.userList = data.Data;
      this.userList.unshift({label: 'Select User', value: ''});
    })
    this.getClientDataException();
    this.getGraphData();
    this.getExceptionList();
    this.getRouteData();
    this.getTradeData();
    this.getOrderData();
    Object.keys(this.selectedRow).forEach((key) => {
      if (this.selectedRow[key as keyof Exceptions] === "") {
          this.selectedRow[key as keyof Exceptions] = " ";
      }
  });
  }

  updateClientDataStaus() {
    this.loading.isClientDataStatus = true;
    this.exceptionDetailsService.updateClientDataExceptionStatus({
      exceptionId: this.selectedRow.OrderExceptionID,
      status: this.updateStatus.status,
      comment:this.updateStatus.comment,
      owner: this.selectedRow.Owner,
      exceptionType: this.pageName,
      updatedBy: this.updateStatus.updatedBy
      }).subscribe((data) => {
        this.messageService.add({ severity: 'success', summary: 'success', detail: data.Data });
        this.getClientDataException();
        this.loading.isClientDataStatus = false;
      })
  }

  getClientDataException() {
    this.activityDetails = [];
    this.tbldatamsg = "L o a d i n g . . . . .";
    this.exceptionDetailsService.getClientDataException({
      exceptionId: this.selectedRow.OrderExceptionID
      })
    .subscribe((data) => {
      this.activityDetails = data.Data;
      if (data.Data.length === 0) {
        this.tbldatamsg = 'No data found';
      }
    })
  }

  getGraphData() {
    this.exceptionDetailsService.getGraphData({
      date: "2016-05-11",
      symbol: this.selectedRow.Symbol,
      datetime: this.selectedRow.DateTime,
      seconds: 5
      }).subscribe((data) => {
        console.log('graph data', data);
      })
  }

  getExceptionList() {
    this.exceptionDetailsService.getExceptionList({exceptionId: this.selectedRow.OrderExceptionID})
    .subscribe((data) => {
      this.exceptionList = data.Data;
      this.totalRecords = this.exceptionList.length;
      this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
    })
  }

  getOrderData() {
    this.exceptionDetailsService.getClientData(APIURL.Orders,this.defaultFilterArray,this.limit,this.pageName, '', this.selectedRow.OrderExceptionID)
    .subscribe({
      next: (Element:any) => {
      this.loading.isOrderDataLoading = false;
      let dataset: any = Element;
      this.orderData = [];
      this.orderData = dataset.Data;
    }, error: (err: HttpErrorResponse) => {
      this.loading.isOrderDataLoading = false;
    }});
  }

  getTradeData() {
    this.exceptionDetailsService.getClientData(APIURL.Trades,this.defaultFilterArray,this.limit,this.pageName, '', this.selectedRow.OrderExceptionID)
    .subscribe({
      next: (Element:any) => {
      this.loading.isTradeDataLoading = false;
      let dataset: any = Element;
      this.tradeData = [];
      this.tradeData = dataset.Data;
    }, error: (err: HttpErrorResponse) => {
      this.loading.isTradeDataLoading = false;
    }});
  }

  getRouteData() {
    this.exceptionDetailsService.getClientData(APIURL.Routes,this.defaultFilterArray,this.limit,this.pageName, '', this.selectedRow.OrderExceptionID)
        .subscribe({
          next: (Element:any) => {
          this.routeData = false;
          let dataset: any = Element;
          this.routeData = [];
          this.routeData = dataset.Data;
        }, error: (err: HttpErrorResponse) => {
          this.loading.isRouteDataLoading = false;
        }});
  }
 
}
